module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e353024"
    }
  }, [_vm._v("CHAPTER 2"), _c('br'), _c('br'), _c('big', [_vm._v("Paths to Uniting"), _c('br'), _vm._v(" with God")])], 1), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e354124"
    }
  }, [_vm._v("When a westerner hears the word “yoga,” his mind goes immediately to a person locked in meditation, sitting upright, cross-legged, palms upward, likely chanting the sound “Om.” In Hinduism, yoga is a spiritual path, a discipline that leads one to actualize his potential. In other words, it is a means to the end of spiritual enlightenment discussed in our first chapter.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e358425"
    }
  }, [_vm._v("Yoga is a well-known word in the West, and is connected etymologically with the English word “yoke,” or “union” of the individual consciousness with the Infinite Consciousness. The term can be loosely translated as “spiritual discipline” or “application.” Yoga is taught by all sects of Hinduism, and it is taught as a means of salvation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e360525"
    }
  }, [_vm._v("There are four kinds of yoga, and it is the combination of the four disciplines that leads us from release to rebirth. The Bhagavad Gita is a classic Hindu text that presents a variety of options for those who desire release from rebirth. There the god Krishna talks about the ways in which humans can find release. One is by fulfilling their caste duties. Another is by practicing the philosophy known as yoga.")]), _vm._v(" "), _vm._m(1), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e363925"
    }
  }, [_vm._v("The significance of the term yoga is profound: Yoga is a method of spiritual training whose purpose is to integrate or unite the self. A physical exercise, its goal is nonphysical—uniting with God. Yoga teaches that people should attempt to yoke the individual spirit to God, to atman—the individual soul or essence of a person—and to Brahman.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e366425"
    }
  }, [_vm._v("What is essential to all yoga is meditation. Meditation is valuable insofar as it enables its practitioners to find release from the endless cycle of birth, death, and rebirth. The early practice concentrated on “yoking in,” or restraining, the senses. Later the word yoga was seen as a metaphor for or “yoking” to God or the divine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e368625"
    }
  }, [_vm._v("Since there are different types of people, different spiritual personality types, Hinduism recognizes a different path for each. Every human being possesses a talent or attribute that could be emphasized in approaching God. As a consequence, there are several forms of yoga, each having different features.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e370625"
    }
  }, [_vm._v("Before a person can even begin on any of the paths, they must undertake some moral preliminaries. This means casting aside bad habits and acquiring good ones, including nonviolence, truthfulness, self-discipline, cleanliness, contentment, and a genuine desire to reach the goal.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e373326"
    }
  }, [_vm._v("People today are tempted to think of yoga as the brainchild of some new-wave philosophy. They might think it originated with some recent guru. In actuality, yoga is about 3,000 years old.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e374826"
    }
  }, [_vm._v("Statues and seals depicting persons in various yogic positions have been found in remains dating back to the third millennium b.c.e.; but the earliest form of yoga as we know it was probably Jain yoga (900 b.c.e.). Jain yoga involved severe sensual denial and restraint. To free the soul from birth and rebirth, Jains felt it was necessary to restrain the senses completely to be beyond both love and hate. In reality, this means to be in control of all positive or negative emotions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e381226"
    }
  }, [_vm._v("As early as 900 b.c.e., the Jain monks and Tirthankaras (perfected beings) would train themselves to ignore the pains and longings of the body completely. Nearly 3,000 years later, the details of such practices are lost to us. Jain yoga today has evolved; it is now focused more on restraining oneself to prevent injury to any living being.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e386526"
    }
  }, [_vm._v("The current philosophy of yoga was developed by the sage Patanjali, who lived in the second century b.c.e. and regulated the teachings of yoga in the Yoga Sutras. The Yoga Sutras are the most important text of hatha yoga, or “posture yoga” tradition. “Sutra” refers to the text style: a collection of concise lines—what are commonly called aphorisms—often requiring further explanation to be fully understood.")]), _vm._v(" "), _vm._m(4), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e394327"
    }
  }, [_vm._v("The Yoga Sutras contain 193 sutras divided into four books. Book I is on concentration and its spiritual uses; Book II outlines the practice and means of reaching the highest goals; Book III details the “powers” gained in the practice of yoga. Book IV is titled “Independence”; it describes various aspects of the nature of things, especially the nature of the liberated state. Scholars believe that the four chapters might have been composed at various times, but they nonetheless comprise a single authoritative text.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e401527"
    }
  }, [_vm._v("Yoga is a method of restraining the natural turbulence and agitation of our thoughts. Without slowing down the mind’s agitation, we cannot glimpse our true nature; as soon as the ripples or waves in a lake have stopped, we see its true nature. So with the mind; when it is calm, we see what our nature is. The third sutra says, “At the time of concentration the seer rests in his own state.” According to Hinduism, the mind is continually transforming itself into the shapes and objects it becomes aware of, a power of transformation that is never at rest.")]), _vm._v(" "), _vm._m(8), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e404927"
    }
  }, [_vm._v("According to Patanjali, a person who has attained certain powers through medicines, words, or mortifications (self-denial) still has desires. But the man who has attained samadhi, which is the highest level of concentration and absorption in yoga, is free from all desires.")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e411228"
    }
  }, [_vm._v("Your mind may be distracted by the desire to rest by playing a game of solitaire. Or your important conversation may be halted by your eyes trailing the form of a beautiful woman as she walks by. A line of music may send you into reverie about a person and a time long past. The yogi knows that a person in samadhi, or the highest state of concentration, is indifferent to such external stimuli.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e413828"
    }
  }, [_vm._v("How does this come about? The control of the mind comes about by practice and nonattachment to objects, according to the twelfth sutra. It has been said that habit is second nature, but this truth is not the whole truth. Habit is first nature, too, and the whole nature of man. Everything that we are is the result of our habits.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e415828"
    }
  }, [_vm._v("The philosophy is positive, even hopeful: We can remedy bad habits with counter habits. In this sense, no person is ever hopeless, because his character—a combination of his habits—can always be replaced by newer and better habits. With practice, you can achieve what the thirteenth sutra counsels: “Constant struggle to keep them [the vrittis, or forms of the world] perfectly restrained in practice.” Nonattachment is the reward of long, continued practice: “That effect which comes to those who have given up their thirst after objects, either seen or heard, and which wills to control the objects, is nonattachment.”")]), _vm._v(" "), _vm._m(10), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e419828"
    }
  }, [_vm._v("In concentrating, you must work toward yoga. An analogy is made between a man and his senses and a charioteer controlling his horses. The sense organs are like horses, the mind the reins, the intellect the charioteer, the soul the rider, and the body the chariot. If the horses are very strong and do not obey the reins, if the charioteer—the intellect—does not know how to control the horses; then the chariot will come to grief.")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e422628"
    }
  }, [_vm._v("Book II of the Yoga Sutras prescribes methods for overcoming the mental “afflictions,” which means all of those things that cause distractions. The real root of ignorance, or having the wrong idea about reality, is discussed here. As the fifth sutra of the second book says, “Ignorance is taking the noneternal, the impure, the painful, and the non-self for the eternal, the pure, the happy, and the atman, or self.” In short, ignorance is treating unimportant, temporal things as truly important, eternal things. Among the things people mistake for being important are pleasures and pains.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e427129"
    }
  }, [_vm._v("Yogis say that the person who has discriminating powers sees through everything called pleasures and pains. Pleasures and pains come to all persons; they are transient, with one passing easily into the other.")]), _vm._v(" "), _vm._m(12), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e428829"
    }
  }, [_vm._v("All people follow an ignis fatuus all their lives, and never succeed in fulfilling their desires. The great king Yudhishthira once said that the most wonderful and truly startling thing in life is that every moment we see people dying around us, and yet we think we shall never die.")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e435929"
    }
  }, [_vm._v("The sound “Om” is believed to be the supreme symbol of God and the sound that expresses all truth. Thus, the priest begins worship and spiritual leaders begin their lessons with Om. In addition, disciples open themselves to those lessons with Om. It is claimed that those in whom the sound resides are unified with God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e439329"
    }
  }, [_vm._v("Holding on to this world will not do; attachment does not serve spiritual advancement. Never did a great soul exist who did not turn his back on sense pleasures and enjoyments. The cause of misery is the clash between the forces of nature—one dragging one way, another dragging the other way, rendering permanent happiness impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e441730"
    }
  }, [_vm._v("The yogi realizes the cause of pain or pleasure is always joining ourselves with the body (sutra 23). It is our ignorance of this that has led to our misery (sutra 24), which is due to our joining ourselves to a particular body. But this idea of body is a superstition caused by ignorance, and leads us to feel heat and cold, pleasure and pain. Yogis teach that it is our task to rise above this superstition. Some people do, so at times, we see a person who is burned but feels no pain. We can get hold of the upheavals of the mind and permanently attain to the separation of self from the body.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e445230"
    }
  }, [_vm._v("In essence, one must conquer one’s own ignorance. This can be done by work, worship, psychic control, philosophy, or some combination of them. To overcome this bondage of nature over us is to achieve freedom. This is the whole of religion. The rest of religion—its metaphysical doctrines, dogmas, rituals, books, and artifacts—rank far behind in importance. Nature versus self: it is a pitched battle for control. What are the stakes?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e448030"
    }
  }, [_vm._v("The stakes are high, indeed. The yogi contends that he who controls mind controls matter, too. The internal nature is much higher than the external; in addition, this internal nature is more difficult to control. If you conquer your internal nature, you can control the entire universe. Book II stresses the goal of practice: discriminating between the real and the unreal.")]), _vm._v(" "), _vm._m(15), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e450830"
    }
  }, [_vm._v("Yoga practice includes truthfulness, continence, and not stealing, killing, or receiving gifts. These are eternal vows, uninterrupted by time, place, caste rules, or other circumstances. They must be observed by every man, woman, and child, regardless of their nation of origin or position in life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e452430"
    }
  }, [_vm._v("Each can be considered in turn. Falsehoods, no matter how small, are sinful. Even mild lies are still lies. The yogi must be true in thought, word, and deed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e454131"
    }
  }, [_vm._v("A yogi must practice the ideal of nonviolence, toward animals as well as people; if you injure animals without concern, you become callous. The sutras say even animals at odds, such as tigers and lambs, will play together in the presence of a nonviolent yogi.")]), _vm._v(" "), _vm._m(16), _vm._m(17), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e458631"
    }
  }, [_vm._v("As regards the giving and receiving of gifts, receiving gifts is prone to undercut the independence of the mind and make individuals slavish. A man who does not make a practice of receiving gifts does not become beholden to others; rather, he remains independent and free.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e460031"
    }
  }, [_vm._v("There are other virtues for the yogi: he should practice cleanliness, and he should be cheerful, not gloomy.")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e461731"
    }
  }, [_vm._v("The third book of the Yoga Sutras begins with a discussion of the internal practices of yoga, including meditation and various levels of concentration, including samadhi, the highest. Concentration is of the utmost importance to quiet the mind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e463431"
    }
  }, [_vm._v("The mind by its nature is in constant agitation; yoga stops this agitation. One metaphor explains the mind as being in a continuous ripple, like the surface of a pond being stirred by a breeze. Like this pond, the mind is ever changing, shimmering with every different influence that captures it at distinct moments.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e465731"
    }
  }, [_vm._v("The mind can never be still—all the impressions our senses experience coming from without would have to cease. In addition, all the impulses from within must also grind to a halt. Memories, emotional pressures, and incitements of the imagination—which are like internal springs, as opposed to the external springs of the objects of sense—are forever active. What can the mind do in the face of this continual onslaught of internal and external stimuli?")]), _vm._v(" "), _vm._m(19), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e469132"
    }
  }, [_vm._v("Patanjali’s yoga has the power to still the mind, which is at the center of a cauldron. His yoga is a technique to rid your mind of the torments, afflictions, and sufferings and bring out the inner perfection of the essential person.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e471132"
    }
  }, [_vm._v("There are five impairments for the mind:")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e483032"
    }
  }, [_vm._v("Among the five hindrances, ignorance is the one that underlies the rest. What are called the goods of life are intrinsically impure, yet people value them as if they were permanent. Nothing could be further from the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e484332"
    }
  }, [_vm._v("The Yoga Sutras teach that through a life perfectly conducted according to these principles, a person can attain a mental level where the five impairments are reduced to practically nothing. Once the impairments have been removed, illumination comes to the mind.")]), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e487233"
    }
  }, [_vm._v("According to the Yoga Sutras, there are eight steps a person must take to achieve the superconscious mental level in raja yoga. This is a “sitting” yoga, which focuses on breathing. As one observes the breath, one develops ways of concentrating the mind and eventually controlling it. Postures are stressed in today’s versions of Patanjali yoga, but Patanjali’s Yoga Sutras do not list any postures.")]), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e493733"
    }
  }, [_vm._v("Employing a method that might be called willed introversion, one can drive the psychic energy of the self inward, to its deepest base.")]), _vm._v(" "), _vm._m(27), _vm._m(28), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e497633"
    }
  }, [_vm._v("The following eight steps achieve the goal of raja yoga—a trance state:")]), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e509634"
    }
  }, [_vm._v("What does each step mean? The first two steps involve the required moral preliminaries common to all four yogas.")]), _vm._v(" "), _vm._m(38), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e511034"
    }
  }, [_vm._v("Unless a meditator’s mind is clear and her life—that is, her relationships to others and herself—follows some semblance of order, self-knowledge is difficult, if not possible, to attain. Thus, step one involves the practice of five moral abstentions—from injury, lying, stealing, sensuality, and greed. Step two includes an additional five observances: cleanliness, contentment, self-control, studiousness, and contemplation of the divine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e514134"
    }
  }, [_vm._v("The third step demands precision regarding the physical requirements of yoga. This means the lotus position: the yogi sits, ideally on a tiger skin— symbolizing energy—covered by a deerskin—symbolizing calm—with legs crossed so each foot rests sole up on its opposing thigh. The spine is now in a natural position, nearly erect, with hands placed palms up in the lap, thumbs touching lightly. The eyes should not be looking off; instead, they should be closed or allowed to fall, unfocused, to the ground.")]), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e523535"
    }
  }, [_vm._v("“Restless the mind is, so strongly shaken by the grip of the senses. Truly I think that the wind is no wilder,” it is written in the Bhagavad Gita.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e524935"
    }
  }, [_vm._v("This step counsels that the constant din of sensory input must be quieted. You hear sounds you ought not to hear and wouldn’t hear if you were concentrating correctly. On the other hand, we don’t hear directives and requests that were intended for us, since we are distracted with other matters. Your spouse tells you to shut off the stove after you’ve boiled the eggs, but you were thinking of the day’s schedule at the time and didn’t hear the directive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e527735"
    }
  }, [_vm._v("Then there is that environmental clatter; the steady, shrill drivel of nonsense from the television or the gossip at the dinner table after a meal. All of this is inviting to an undisciplined mind. But a disciplined mind set on spiritual advancement must tune it out, as if shutting off a switch. For the yogi bent on making progress, concentration must cease to be a random occurrence and commence to be a controlled skill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e530435"
    }
  }, [_vm._v("The sixth step involves extreme concentration, or what is more often called focus (dharana). The Katha Upanishad says, “When all the senses are stilled, when the mind is at rest, when the intellect wavers not—that, say the wise, is the highest state.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e533036"
    }
  }, [_vm._v("Stated thus, it is easier said than done. Our minds are routinely unwieldy, more prone to activity than stillness. No sooner do we concentrate on some bit of music, dialogue, or calculation, than poof—off our mind goes, exploring the landscape of some other matter. From there it is distracted once again, foraging over the surface of some new matter. You find yourself in conversation with a person and suddenly their head snaps left or right, eyes trained on someone walking by.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e535636"
    }
  }, [_vm._v("The would-be yogi, or even advanced yogi, is in need of a mental tune-up, always struggling to cultivate stronger powers of concentration. To attain this end, some dedicated work is required. The method has two parts. The first is relaxing the mind in order to free thoughts and feelings formerly repressed. With the hornet’s nest of the unconscious now stirred up, try your skill at concentrating on some object.")]), _vm._v(" "), _vm._m(42), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e538336"
    }
  }, [_vm._v("You can concentration on anything: a billiard ball sitting on the green baize, the relentless waves pounding the shore. The choice of an object matters less than the ability of the mind to stay focused on the object.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e539636"
    }
  }, [_vm._v("In step seven, one goes beyond step six in an important way. In step six, you focused on some object, all the while aware that you were doing so—you were aware of your awareness. But in the seventh step, you drop out of the equation. The object now occupies your attention utterly, with no room remaining for self-consciousness or awareness that you are doing so. In essence, there is no split between self and other; at this point, you have achieved meditation (dhyana).")]), _vm._v(" "), _vm._m(43), _vm._m(44), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e546737"
    }
  }, [_vm._v("In step eight, you finally achieve the sought-after union with a supreme being. In this stage, known as samadhi, even the object of contemplation disappears. The limited object of your contemplation now gone, your mind finds union with the infinite, with the Brahman. This infinite substance excludes nothing—it is formless. It is “separated from all qualities, neither this nor that, without form, without a name,” as the Upanishads say. You have contacted total being.")]), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e555237"
    }
  }, [_vm._v("Jnana knowledge is not factual information or book knowledge; it has more to do with discernment, reflection, and intuition. The intuitive knowledge in question transforms the knower into the likeness of what he knows. self-knowledge is most important, and the realization of this comes after three stages.")]), _vm._v(" "), _vm._m(47), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e558737"
    }
  }, [_vm._v("self-realization will come about only after distinguishing between the surface of reality and the true reality that lies underneath. The first stage is hearing. You listen to sages and scriptures and you come to realize that your essential nature is being itself. Your second step is thinking. It is by prolonged, intensive introspection that you can become hyperaware of your own thought processes and language and how they might lead you astray.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e561337"
    }
  }, [_vm._v("For example, the words “me” or “my” imply a duality, a separation between the possessor and what is possessed. A person is misled to embrace this dual thinking when she uses other possessive language—such as “my body,” “my mind,” “my personality,” all of which imply her separation from the world around her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e563638"
    }
  }, [_vm._v("Further, even as almost everything about her physical self has changed over time, there is some enduring part of her that is unchanging. There is an enduring self, even as a surface, transient self undergoes change. The third step then becomes her identification with this enduring part of herself, as opposed to her surface self. In this way, she comes closer to her fuller self— the self that is identical with Brahman.")]), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e576638"
    }
  }, [_vm._v("Repetition of the divine name is essential for complete self-surrender to God. There are calamities aplenty in the world—Earthquakes, hurricanes, floods, plagues, famines, food scarcity—but there is no calamity that will not yield to the divine name. Therefore, for the good of India and the world at large, everyone should repeat and sing the divine name, both for worldly gains and otherworldly peace and happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e578738"
    }
  }, [_vm._v("The yoga developed in the Bhagavad Gita was called devotional yoga; in bhakti yoga, our lives are steered less by reason than by emotion, with the strongest emotion by far being love. The goal of bhakti yoga is to approach God with love and devotion. Perhaps because it draws on the emotion found in all persons, bhakti yoga is the most popular of the four yogas.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e582038"
    }
  }, [_vm._v("In jnana yoga, God is the infinite, a constant being beneath the fluctuations of day-to-day reality. This God is impersonal—or transpersonal; but to the bhakti aspirant, feelings bear greater importance than thoughts.")]), _vm._v(" "), _vm._m(51), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e585139"
    }
  }, [_vm._v("Even if yoga’s steps don’t lead you to a union with God, they may aid you in uniting with the task at hand, whatever it happens to be. All of us require concentration—and at times supreme concentration—to achieve our separate ends. Yoga can aid and abet the achievement of those objectives; in this sense, yoga is a supremely practical enterprise.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e587039"
    }
  }, [_vm._v("It is the bhakti yogi’s goal not to identify with God, but to adore God. If you love God dearly, love God only, and love for no ulterior reason but for love’s sake alone, you can know joy. But this is an objective only—how can you achieve it? At first it may seem like a very difficult thing to do; and yes, you must undertake a few measures to fully attain love of God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e589139"
    }
  }, [_vm._v("One of these measures is to enter Hinduism’s myths and symbols. It could be that a symbol of Krishna might remind you of God’s awe-inspiring power. Stories and legends about the gods impart ideals and morals, hopefully leading readers to imitate what they learn. Prayer, meditation, purifying, worshiping, devotion, reading—all of these activities should move us in God’s direction.")]), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e597139"
    }
  }, [_vm._v("Ringing the changes on love is the second activity, encouraging all bhaktas to behold the vast differences in the kinds of love in our lives. Love takes many forms. There is the love of a parent for children, which of necessity includes a spirit of protectiveness. The reverse, of course, is not true; a child’s love is shaped around his dependency on his parents. The love between friends can be platonic or based on some kind of reciprocity, or take any number of other forms. This contrasts with the conjugal love between woman and man. Awe may describe the feelings of a servant for a master, while the master may return this with a paternal spirit. A bhakta who understands these varieties of love may well increase his love of God as a consequence.")]), _vm._v(" "), _vm._m(54), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e606640"
    }
  }, [_vm._v("Thus, one who grew up in a Shaivite family will likely choose a Shaivite deity to worship. Shiva is the Destroyer, Nataraja—Lord of the Dance— known to all India, since his form is found in most temples. He is also the Lord of Chaos, who destroys the universe with his final dance. But the name Shiva means “the beneficent one,” and he can just as easily dance that same universe back into existence again if he so desires.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e609640"
    }
  }, [_vm._v("It is not unusual for worshippers to choose divinities outside their sectarian context. Thus, it is not impossible for a Bengali Vaishnavite (devotee of Vishnu) to choose Kali, the fierce goddess, as ishta devata. Whatever the choice, the most effective ishta will be one of God’s incarnations, for the human heart is naturally turned to loving people.")]), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e617140"
    }
  }, [_vm._v("The term “karma” refers to the law of action. According to this ethical concept, the actions or karmas of people in their current births shape their lives in their next births. Another sense of the term comes from the Bhaga-vad Gita, where karma yoga refers to a yoga of action in the world without regard to its fruits. To find a famous exemplar of this concept you needn’t look further than Mohandas K. Gandhi. Gandhi embodied karma yoga and made the term well known, since his political actions were undertaken in the name of karma yoga.")]), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e624041"
    }
  }, [_vm._v("Hinduism proclaims that every action directed toward the external world reacts on the doer. For instance, if you performed all work for your private benefit, you have only succeeded in bolstering your own ego and increased your distance from God. On the other hand, selfless action takes you out of yourself and toward the divine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e626141"
    }
  }, [_vm._v("The mode of the philosopher is one of detachment. A person acting in jnana mode accepts the notion of an infinite being at the center of her being, rather than a providential father.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e627541"
    }
  }, [_vm._v("In bhakti mode, personal rewards are not first and foremost in the mind; instead, acts are now performed as a service to God. Moreover, when this working for God takes hold of the individual, she is transformed; she is powered by God’s will and prompted by God’s energy. A spirit of “Thou art the Doer, I am the instrument” imbues the individual.")]), _vm._v(" "), _vm._m(59), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e637742"
    }
  }, [_vm._v("Yoga developed in special ways, especially by the tantric schools of the Middle Ages. The “yoga of dissolution,” laya yoga, is often identified with hatha yoga, based on ancient Indian physiological notions that play a major part in the form of yoga taught by Western practitioners. Hatha yoga emphasizes the importance of physical means, such as special acrobatic exercises and very difficult postures, and sometimes advocates sexual union as a means of salvation.")]), _vm._v(" "), _vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _vm._m(68), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e664043"
    }
  }, [_vm._v("The rest of the centers are superior centers. The fourth chakra lies at the level of the heart, and is the lotus in which the first realization of the divinity of the world is experienced. Here, the god reaches down to touch his devotee.")]), _vm._v(" "), _vm._m(69), _vm._v(" "), _vm._m(70), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e670443"
    }
  }, [_vm._v("The seventh chakra, the crown, is considered the seat of cosmic consciousness. In its fully opened state, it is perceived as a thousand-petal lotus effulgent with light. The tantric worshipper is supposed to imagine himself as having purified his body by suffusing all the lotuses with the awakened kundalini in this way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e673243"
    }
  }, [_vm._v("The awakened kundalini gives the yogi superhuman power and knowledge, and many yogis have practiced yoga for this rather than for salvation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e674643"
    }
  }, [_vm._v("Some adepts of this form of yoga have developed powers that cannot fully be accounted for by modern medical science and that cannot be explained away as subjective, but the physiological basis of laya and hatha yoga is certainly false; there is no physical kundalini, susumna or sahasrara.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e677643"
    }
  }, [_vm._v("As A. L. Basham exhorts, “The ancient mystical physiology of India needs study, not only by Indologists, but by open-minded biologists and psychologists, who may reveal the true secret of the yogi.”")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e357925"
    }
  }, [_c('i', [_vm._v("Yoga ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0025_001",
      "src": "images/9781598698626_0025_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e372826"
    }
  }, [_c('i', [_vm._v("Yoga over Time ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e385826"
    }
  }, [_c('i', [_vm._v("Patanjali and the Yoga Sutras ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0026_001",
      "src": "images/9781598698626_0026_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e391326"
    }
  }, [_c('b', [_vm._v("What is known about the sage Patanjali?")]), _c('br'), _vm._v("According to tradition, Patanjali was an incarnation of the divine serpent Adishesha. Patanjali is often depicted with the lower body of a snake and a canopy of five serpent heads.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e397327"
    }
  }, [_c('i', [_vm._v("The Yoga Sutras on Concentration: Books I and II ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e397827"
    }
  }, [_vm._v("The Yoga Sutras begin with a simple sutra numbered one: “Now concentration is explained.” Sutra two says yoga is a restraining of the individual consciousness ("), _c('i', [_vm._v("chitta")]), _vm._v(") to control "), _c('i', [_vm._v("vrittis ")]), _vm._v("(thoughts, feelings, and emotions). Book I begins with a definition: “Yoga is the practice of ceasing the false identification with the fluctuations of the mind.” What could this mean?")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0027_001",
      "src": "images/9781598698626_0027_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e407627"
    }
  }, [_vm._v("Yoga philosophy teaches that the whole of nature consists of three qualities, or forces. These three show up in the spiritual world as darkness or inactivity ("), _c('i', [_vm._v("tamas")]), _vm._v("), attraction or repulsion ("), _c('i', [_vm._v("rajas")]), _vm._v("), and the equilibrium of the two ("), _c('i', [_vm._v("sattva)")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0028_001",
      "src": "images/9781598698626_0028_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e422128"
    }
  }, [_c('i', [_vm._v("Book II ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0029_001",
      "src": "images/9781598698626_0029_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e431429"
    }
  }, [_vm._v("A yogi observes that even the love between husbands and wives, children and friends, slowly decays. The desires of this world are vain and dreamlike. Frustrated with the ephemeral nature of this world and its continued disappointments, the yogi then glimpses "), _c('i', [_vm._v("vairagya ")]), _vm._v("(renunciation). Freedom from attachment brings with it the promise of what lies beyond. If the yogi leaves this world of the senses, then there is hope of bringing the eternal into this life.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0029_001",
      "src": "images/9781598698626_0029_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0030_001",
      "src": "images/9781598698626_0030_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0031_001",
      "src": "images/9781598698626_0031_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e455931"
    }
  }, [_c('b', [_vm._v("What is a yogi’s view of sex?")]), _c('br'), _vm._v("A yogi must be continent, meaning self-controlled, specifically with regard to sexual appetites; thus, a perfect yogi must renounce sexual ideas. The soul has no sex, so why should it degrade itself by being sexually preoccupied? Chastity yields tremendous energy; without it there can be no spiritual strength.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e461131"
    }
  }, [_c('i', [_vm._v("Powers: The Yoga Sutras Book III ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0032_001",
      "src": "images/9781598698626_0032_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e471832"
    }
  }, [_vm._v("1. "), _c('i', [_vm._v("Avidya: ")]), _vm._v("Avidya is commonly translated as ignorance. It is the fundamental ignorance that causes us to misperceive the phenomenal world. This ignorance makes us believe that what we see is the only reality, when in actuality there is an underlying reality that transcends the mundane sphere, though it is not apparent to ordinary vision.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e474532"
    }
  }, [_vm._v("2. "), _c('i', [_vm._v("Asmita")]), _vm._v(": Asmita means “I am.” This impairment leads a person to think his self is separate from reality and is the essence of his being.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e476232"
    }
  }, [_vm._v("3. "), _c('i', [_vm._v("Raja")]), _vm._v(": Raja is one of the three "), _c('i', [_vm._v("gunas ")]), _vm._v("of worldly existence. It refers to attachment, sympathy, and interest or affection of every kind. Yogic practice tries to realize the self beyond and untouched by the three gunas of worldly existence.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e478832"
    }
  }, [_vm._v("4. "), _c('i', [_vm._v("Dvesa")]), _vm._v(": Dvesa is the feeling contrary to raja. Instead of attachment, it is disinclination, distaste, dislike, repugnance, and hatred. Dvesa and raja together tear the soul this way and that, upsetting its balance.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e481132"
    }
  }, [_vm._v("5. "), _c('i', [_vm._v("Abhinivesa")]), _vm._v(": Abhinivesa is a clinging to life as a process that should go on without end.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e486733"
    }
  }, [_c('i', [_vm._v("Raja Yoga: Mental and Spiritual Development ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e490433"
    }
  }, [_vm._v("Raja yoga is known in India as “the royal ("), _c('i', [_vm._v("raj")]), _vm._v(") road to reintegration.” The goal of the meditative exercise is to achieve “the beyond within.” The yogi or yogini (female) is involved in introspection, the result of which is to uncover the four layers of the self. This self is composed of a body; next comes the conscious layer of our minds; underlying these two is an individual subconscious, which contains bits of our own personal histories. The fourth layer is being itself—infinite and eternal.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0033_001",
      "src": "images/9781598698626_0033_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e495133"
    }
  }, [_c('b', [_vm._v("What is the most common posture during yoga?")]), _c('br'), _vm._v("The most frequent of all yoga postures used in meditation is the so-called lotus position. A person sits cross-legged—right foot upon the left thigh, the left foot upon the right thigh, with back erect. Concentration is thought to be easier in such a centered or balanced position, where you are not attending to the comforts and discomforts of the body.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e498333"
    }
  }, [_vm._v("1. Before you can progress, you must take certain vows of restraint ("), _c('i', [_vm._v("yama")]), _vm._v("). These vows include not harming living creatures, and chastity.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e500134"
    }
  }, [_vm._v("2. At this stage, you attempt to achieve internal control, calmness, and equanimity ("), _c('i', [_vm._v("niyama")]), _vm._v(").")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e501434"
    }
  }, [_vm._v("3. In the third stage, you learn and practice certain bodily postures ("), _c('i', [_vm._v("asana")]), _vm._v(") designed to help achieve the aims of yoga.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e502734"
    }
  }, [_vm._v("4. Once the postures have been mastered, you work on breath control ("), _c('i', [_vm._v("pranayama")]), _vm._v(").")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e504134"
    }
  }, [_vm._v("5. The fifth stage is control of the senses ("), _c('i', [_vm._v("pratyahara")]), _vm._v("), in which you seek to shut out the outside world.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e505434"
    }
  }, [_vm._v("6. The sixth stage is extreme concentration on a single object ("), _c('i', [_vm._v("dharana")]), _vm._v("). ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e506534"
    }
  }, [_vm._v("7. Then one seeks to achieve meditation ("), _c('i', [_vm._v("dhyana")]), _vm._v(").")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e507634"
    }
  }, [_vm._v("8. Finally, you seek a trance ("), _c('i', [_vm._v("samadhi")]), _vm._v("), in which you become one with the Brahman.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e509134"
    }
  }, [_c('i', [_vm._v("Breaking Down the Eight Steps ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0034_001",
      "src": "images/9781598698626_0034_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e516534"
    }
  }, [_vm._v("The fourth step focuses on breath control ("), _c('i', [_vm._v("pranayama")]), _vm._v("). Having achieved relaxation in your body, you now turn to controlling your breath. It is believed that if the mind is breathing randomly it might be perturbed, so evenness of breath is one ideal. Another is breath reduction. Ideally, breathing should be gentle and sparse; abstention from breathing can lead the body to be still, allowing the mind to achieve a state where it seems disembodied. This facilitates the effectiveness of the meditation. As it is written in the Bhaga-vad Gita, “The light of a lamp does not flicker in a windless place.”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e520635"
    }
  }, [_vm._v("The fifth step of controlling the senses ("), _c('i', [_vm._v("pratyahara")]), _vm._v(") cannot be overemphasized. In order to contemplate effectively, you cannot be distracted by the passing parade, that steady stream of sights and sounds that interrupt your calm repose. How can you fight the onslaught of objects and sensory stimuli that unsettle you and split your concentration?")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0035_001",
      "src": "images/9781598698626_0035_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0036_001",
      "src": "images/9781598698626_0036_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0036_002",
      "src": "images/9781598698626_0036_002.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e542936"
    }
  }, [_c('b', [_vm._v("What is meditation?")]), _c('br'), _vm._v("The word comes from the Latin root meditare, with the Latin mederi meaning “to heal.” So, meditation is the art of healing all physical and mental ailments. Hinduism talks about twenty different levels of consciousness or mental stages. Meditation is the art of making the mind still.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e549637"
    }
  }, [_c('i', [_vm._v("Jnana Yoga: The Way to God Through ")]), _c('i', [_vm._v("Knowledge ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e550637"
    }
  }, [_vm._v("The term derives from a root "), _c('i', [_vm._v("jna ")]), _vm._v("which means “to know.” The knowledge being referred to in jnana yoga has to do with the unity between the highest realization, or Brahman and the individual self, or "), _c('i', [_vm._v("Jivatman")]), _vm._v(". The role of jnana is explained in the Upanishads and is most clearly outlined in the "), _c('i', [_vm._v("advaita ")]), _vm._v("(nondualist) philosophy of Shankara.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e558137"
    }
  }, [_c('i', [_vm._v("The Three Stages of Knowing ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e565938"
    }
  }, [_c('i', [_vm._v("Bhakti Yoga: The Path to God Through Love ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e566638"
    }
  }, [_vm._v("The road to God through knowledge may be a direct path for many seekers of wisdom, but it is also a steep path. The word "), _c('i', [_vm._v("bhakti ")]), _vm._v("means “to adore, honor, worship.” In the Vedic tradition, going back to 1500 b.c.e., the religious practice of Hinduism relied on chanting the name of God and making offerings to various divinities. In current times, those who praise Krishna or some other manifestation of God might chant “Hare Krishna, Hare Krishna” repeatedly, which means “Praise Krishna.”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e571838"
    }
  }, [_vm._v("The bhakti yogi believes that, “The utterance of the Lord’s name completely destroys all sin.” The "), _c('i', [_vm._v("japa ")]), _vm._v("discipline includes the repetitive recitation of the “mantra of the sixteen names,” the “great mantra” for the japa of Krishna bhaktas: “Hare Rama Hare Rama Hare Rama Hare Rama Hare Krishna Hare Krishna Hare Krishna Hare Krishna.”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0039_001",
      "src": "images/9781598698626_0039_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e592039"
    }
  }, [_c('i', [_vm._v("Three Bhakti Yoga Activities ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e592939"
    }
  }, [_vm._v("Religious author Houston Smith maintains that three activities in particular may aid and abet our approach to God. The bhakta’s approach should involve "), _c('i', [_vm._v("japam, ")]), _vm._v("ringing the changes on love, and the worship of one’s chosen ideal. Japam is the practice of repeating God’s name. If you keep the name of the Lord before you, the very repetition of the sound can penetrate the subconscious mind and fill it with holiness. Whatever the swirl of your daily activities happens to be, the name of the Lord can be summoned to mind and kept on your lips.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e602240"
    }
  }, [_vm._v("Finally, one involved in bhakti yoga will worship God in the form of his chosen ideal or "), _c('i', [_vm._v("ishta")]), _vm._v(". "), _c('i', [_vm._v("Ishta devata")]), _vm._v("—or “desired divinity”—is an invaluable concept in theistic Hinduism. Each person has a divinity that best suits his personal inclinations and way of life. It is highly likely that he will choose an ishta devata according to the sectarian mode of Hinduism he grew up with.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e612940"
    }
  }, [_c('i', [_vm._v("Karma Yoga: The Way to God Through Work ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e613440"
    }
  }, [_vm._v("A last way of approaching God is through work. If you work not only to survive but also because you enjoy your work, you can find God in this manner. What is required is that the work takes you in a direction toward God, not away from God. Indian philosophy contrasts the "), _c('i', [_vm._v("karma kanda ")]), _vm._v("(action aspect) of tradition with "), _c('i', [_vm._v("jnana kanda ")]), _vm._v("(the knowledge aspect).")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e621041"
    }
  }, [_vm._v("But everything depends on how the yogi approaches work. One possibility is to approach work reflectively; another possibility is to approach it in a spirit of love. The first mode would be jnana yoga, the second, bhakti"), _c('i', [_vm._v(". ")]), _vm._v(" What difference will it make?")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serl"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781598698626_0041_001",
      "src": "images/9781598698626_0041_001.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e630041"
    }
  }, [_c('i', [_vm._v("Yoga Today ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e630641"
    }
  }, [_vm._v("What is the meaning of the term “yoga” as it is popularly used today? First, how much has the yoga landscape changed over the last two millennia? The short answer is that much is the same, and there are some differences. The practices for increasing "), _c('i', [_vm._v("sattvic")]), _vm._v(", or pure, qualities are known collectively as yoga. Yoga, the tradition with which Sankhya is paired, still sets out the principles of discipline required for achieving liberation.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e634642"
    }
  }, [_vm._v("The methods of yoga are called "), _c('i', [_vm._v("sadhanas")]), _vm._v(". The different methods to achieve liberation remain, such as hatha yoga, kundalini yoga, mantra yoga, jnana yoga, karma yoga, and bhakti yoga. The means to the ends, therefore, are much the same as ever.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e641642"
    }
  }, [_c('i', [_vm._v("Kundalini Yoga and Chakras ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e642642"
    }
  }, [_vm._v("In kundalini yoga, the body is thought to exist within a field of energy that is most concentrated in the seven major "), _c('i', [_vm._v("chakras ")]), _vm._v("(wheels), that is, subtle centers along the chief vein of the body, known as "), _c('i', [_vm._v("susumna ")]), _vm._v("(channel)"), _c('i', [_vm._v(". ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e645342"
    }
  }, [_vm._v("In the first chakra, "), _c('i', [_vm._v("muladhara")]), _vm._v(", the lowest “wheel,” behind the genitals, is the "), _c('i', [_vm._v("kundalini")]), _vm._v(", the “serpent power,” which is generally in a quiescent state. By yogic practices, however, the kundalini is awakened, rises through the susumna, passes through all the seven “wheels” of psychic force, and unites with the topmost, sahasrara. By awakening and raising his kundalini, the yogi gains spiritual power, and by uniting it with sahasrara, he wins salvation.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e650242"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("sadhaka, ")]), _vm._v("or devotee, in the tantric rite imagines the divine power ("), _c('i', [_vm._v("shakti")]), _vm._v(") asleep within him, coiled away like a sleeping serpent (kundalini) at the root of his spine. While carefully controlling his inhalations, the sadhaka breaths deeply first through one nostril and then the other ("), _c('i', [_vm._v("pranayama")]), _vm._v("), to clear the way for the kundalini in the spiritual channel. He then thinks of her as aroused; she lifts her head and begins to move up the susumna, touching a number of “centers” or “lotuses” (the chakras) regarded as the seats of the elements of the body. The muladhara is the seat of “Earth”; it is pictured as a crimson lotus of four petals.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e657643"
    }
  }, [_vm._v("The second chakra, called "), _c('i', [_vm._v("svadhisthana ")]), _vm._v("(Shakti’s own abode), is at the level of the genitals and is the seat of the element water. It is often depicted as a vermilion lotus of six petals.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e659843"
    }
  }, [_vm._v("The third chakra lies at the level of the navel and is known as "), _c('i', [_vm._v("manipura, ")]), _vm._v("the city of the lustrous gem, so called because it is the seat of element fire. It is sometimes pictured as a blue-black lotus of ten petals. According to the psychology of this system of lotuses, muladhara, svadhisthana, and mani-pura are the centers from which the lives of most people are governed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e663543"
    }
  }, [_c('i', [_vm._v("Superior Centers ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e665943"
    }
  }, [_vm._v("The fifth chakra, ether, the ultimate element in the universe, is a smoky purple hue and is made of sixteen petals, at the level of the throat. This is the "), _c('i', [_vm._v("visuddha ")]), _vm._v("chakra, which means “the completely purified.”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e667943"
    }
  }, [_vm._v("The sixth chakra is called the third eye. Beyond this point between the eyebrows, is the lotus of command ("), _c('i', [_vm._v("ajna")]), _vm._v("), where the mind is free of limitations. This is when the devotee sees the Lord. It is considered the center that manifests the power of the will and allows spiritual insight.")])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-697c4c5f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anth_9781605507507_epub_c12_r1.vue
// module id = 93
// module chunks = 0